import React, { useEffect, useState } from 'react';
import { StyleProp, TextStyle } from 'react-native';
import { thirdPartyApprovedCompaniesService } from '../../services/central-api/third-party-approved-companies';
import { translate } from '../../services/translate';
import FormDropDownPicker from '../FormDropDownPicker';
import { UseFormReturn } from 'react-hook-form';

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    zIndex: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    required?: boolean;
}

export default function CloudProviderDropdown({ form, fieldName, zIndex, labelStyle, viewStyle, required }: Props) {
    const [selectableCloudProvider, setSelectableCloudProvider] = useState<{ label: string; value: string; }[]>([]);

    async function loadCloudProviders() {
        try {
            const cloudProviders = await thirdPartyApprovedCompaniesService.getSimplifiedPublishedCloudProviders();
            setSelectableCloudProvider(cloudProviders.map((cloudProvider) => {
                return {
                    value: cloudProvider.id,
                    label: cloudProvider.tradeName,
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        loadCloudProviders();
    }, []);

    return (
        <FormDropDownPicker
            form={form}
            fieldName={fieldName}
            label={translate('cloudProvider')}
            items={selectableCloudProvider}
            multiple={false}
            required={required}
            zIndex={zIndex}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />
    );
}
